import { render, staticRenderFns } from "./courseDetail.vue?vue&type=template&id=ebd9eeae&scoped=true"
import script from "./courseDetail.vue?vue&type=script&lang=js"
export * from "./courseDetail.vue?vue&type=script&lang=js"
import style0 from "./courseDetail.vue?vue&type=style&index=0&id=ebd9eeae&prod&lang=less&scoped=true"
import style1 from "./courseDetail.vue?vue&type=style&index=1&id=ebd9eeae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd9eeae",
  null
  
)

export default component.exports